import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { getNCFileById } from '@reducers/manufacture';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { PartSearchItem, ProductionBatchStatistics } from '@interfaces/search';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import { View } from 'react-native';
import { getPartByID } from '@reducers/parts';

interface BatchDetailsPartDocumentsProps {
  batch: ReducerEntityWithLoadingState<ProductionBatchStatistics | null>;
  partId: number | null;
}

const BatchDetailsPartDocumentsComponent: FC<BatchDetailsPartDocumentsProps> = ({
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  getPartByID,
  partId,
  batch,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
    getPartByID,
  });

  const links = batch?.data?.links;
  const currentPartId = links?.length === 0 ? partId : batch?.data?.links?.[0]?.partId;

  return (
    <DetailsPageWrapper title={title.part}>
      {currentPartId && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={currentPartId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Part} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const BatchDetailsPartDocuments = connect(({ batch: { batch }, details: { partId } }) => ({ batch, partId }), {
  clearTools,
  getNCFileById,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  getPartByID,
})(BatchDetailsPartDocumentsComponent);

export { BatchDetailsPartDocuments };
